<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.5 2.20353C0.5 1.2627 1.2627 0.5 2.20353 0.5H22.7965C23.7374 0.5 24.5001 1.2627 24.5001 2.20353V22.7965C24.5001 23.7373 23.7374 24.5 22.7965 24.5H2.20353C1.2627 24.5 0.5 23.7373 0.5 22.7965V2.20353Z" fill="#0A66C2" />
    <path d="M5.8945 7.95355C7.04436 7.95355 7.9765 7.02141 7.9765 5.87155C7.9765 4.72169 7.04436 3.78955 5.8945 3.78955C4.74464 3.78955 3.8125 4.72169 3.8125 5.87155C3.8125 7.02141 4.74464 7.95355 5.8945 7.95355Z" fill="white" />
    <path d="M9.88326 9.49221H13.3338V11.0729C13.3338 11.0729 14.2702 9.20021 16.8178 9.20021C19.0905 9.20021 20.9731 10.3198 20.9731 13.7323V20.9283H17.3974V14.6042C17.3974 12.5912 16.3226 12.3698 15.5037 12.3698C13.8041 12.3698 13.5131 13.8358 13.5131 14.8668V20.9283H9.88326V9.49221Z" fill="white" />
    <path d="M4.07957 9.49222H7.70944V20.9283H4.07957V9.49222Z" fill="white" />
  </svg>
</template>
